<template>
    <div class="jr-component">
      <div class="jr-table">
        <el-table v-bind="$attrs" :id="components.tableId" :size="size" :data="tableData" border :show-summary="showSummary" :ref="components.tableId">
          <el-table-column :key="0" v-if="selection" type="selection" label="#" width="55"></el-table-column>
          <el-table-column :key="1" v-if="index" type="index" width="50"></el-table-column>
          <!-- <el-table-column prop="userId" label="userId" width="500" :sortable="sortable"></el-table-column> -->
          
          <template v-for="(item, i) in components.tableColumns">
           
            <el-table-column v-if="item.columnType != 'Date' && item.columnType != 'Datetime' && item.columnVisible"
            :key="i+2"
            :sortable="true"
            :show-overflow-tooltip="true"
            :resizable="true"
            :prop="item.columnName"
            :label="item.columnDisplayname"
            :width="item.columnWidth"
            />  
            <pl-table-column v-if="item.columnType == 'Date' && item.columnVisible"
            :key="i+2"
            :sortable="true"
            :show-overflow-tooltip="true"
            :resizable="true"
            :prop="item.columnName"
            :label="item.columnDisplayname"
            :width="item.columnWidth"
            :formatter="dataFormat"
            /> 
            <pl-table-column v-if="item.columnType == 'Datetime' && item.columnVisible"
            :key="i+2"
            :sortable="true"
            :show-overflow-tooltip="true"
            :resizable="true"
            :prop="item.columnName"
            :label="item.columnDisplayname"
            :width="item.columnWidth"
            :formatter="datatimeFormat"
            /> 
          </template>
        </el-table>
        <el-pagination 
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="1"
          :page-sizes="[100, 200, 500, 400]"
          :page-size="100"
          layout="total, sizes, prev, pager, next, jumper"
          :total="400">
        </el-pagination>
      </div>
      <!-- <i @click="rightClick" v-if="badge & BadgeType" class="el-icon-success jr-right-ico" style="color: green;"/>
      <i @click="rightClick" v-if="badge & !BadgeType" class="el-icon-error jr-right-ico" style="color: red;"/> -->
    </div>
</template>
<script>
import store from '@/store'
export default {
  name: 'JrTable',
  data() {
    return {
      bigtableVisible: false,
      columnDataProps: {},
      tableHeight: 400,
      tableWidth: 1024
    }
  },
  props: {
    value: {},
    components: {},
    size: {
      type: String,
      default: 'mini'
    },
    // 是否启用多选
    selection: {
      type: Boolean,
      default: true
    },
    // 是否显示行号
    index: {
      type: Boolean,
      default: true
    },
    // 排序方式
    sortable:{
      type: [Boolean, String],
      default: true
    },    
    // 数据对象
    tableData: {},
    // 是否显示汇总行
    showSummary: {
      type: Boolean,
      default: true
    },
    // 会总行字段
    totalOption: {},
    // 会总行数据，只有启用后台汇总的时候才使用
    summaryData: {},
    // 是否显示分页器
    pagination: {
      type: Boolean,
      default: true
    },
    pageTotal: {
      type: Number,
      default: 0
    }
    
  },
  methods: {
    rightClick() {
      this.$emit('badge-click', this.id, !this.BadgeType)
    },
    handleSizeChange(val) {
      this.$emit('size-change', val)
    },
    handleCurrentChange(val) {
      this.$emit('current-change', val)
    }
  }
}
</script>
<style scoped lang="scss">  
  .jr-table{
    width: 800px;
    height: 400px; 
  }
  
  
</style>


// WEBPACK FOOTER //
// src/components/componentsjr/JrTable.vue